import { render, staticRenderFns } from "./DocomoMarker.vue?vue&type=template&id=8b3befc2&"
import script from "./DocomoMarker.vue?vue&type=script&lang=js&"
export * from "./DocomoMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports